<template>
  <div class="cms-youtube-cid">
    <el-dialog
      title="Insert a new keyword"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialog(false)"
    >
      <el-form label-position="top">
        <el-form-item label="Label" prop="label">
          <el-input type="text" v-model="keyword.label" clearable />
        </el-form-item>
        <el-form-item label="Keywords" prop="keywords">
          <el-input type="text" v-model="keyword.keywords" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapState('youtubeKeywords', ['dialog', 'loading', 'keyword']),
  },

  methods: {
    ...mapActions('youtubeKeywords', ['insert']),
    ...mapMutations('youtubeKeywords', ['setDialog']),

    submit() {
      this.insert()
    },

  }
}
</script>

<style scoped lang="scss">

</style>
